import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=5d04cdb0&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=5d04cdb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04cdb0",
  null
  
)

export default component.exports